// extracted by mini-css-extract-plugin
export default {"root":"evaluateExam_root__UfSsY","main":"evaluateExam_main__3GVfO"};